import { render, staticRenderFns } from "./update-colors.vue?vue&type=template&id=49e91e5f&"
import script from "./update-colors.vue?vue&type=script&lang=js&"
export * from "./update-colors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports